import { Tooltip, TooltipProps } from '@mui/material'
import { withStyles } from '@mui/styles'
import { ReactElement, ReactNode, useState } from 'react'
import { isCypress } from 'utils/cypress'
import { isTestEnv } from 'utils/env'

interface GroupcalTooltipProps {
  children: ReactElement | ReactNode
  title: ReactNode
  delay?: number
  color?: string
  enterDelay?: number
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top'
  backgroundColor?: string
  textColor?: string
  textSize?: string
  enterNextDelay?: number
  hidden?: boolean
}

export default function GroupcalTooltip(props: GroupcalTooltipProps) {
  // State to control tooltip visibility
  const [isTooltipVisible, setIsTooltipVisible] = useState(false)

  if (props.hidden || isCypress()) {
    return <div>{props.children}</div>
  }

  return (
    <Tooltip
      leaveDelay={200}
      enterDelay={props.enterDelay ?? 500}
      enterNextDelay={props.enterNextDelay ?? 600}
      placement={props.placement ?? 'bottom'}
      title={props.title}
      slotProps={{
        tooltip: {
          sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '4px 6px',
            fontSize: props.textSize ?? '12px',
            lineHeight: '22px',
            letterSpacing: '0.5px',
            margin: '4px !important',
            backgroundColor:
              props.backgroundColor || 'default-background-color',
            color: props.textColor || 'default-text-color'
          }
        }
      }}
    >
      {/* This div now controls the visibility of the tooltip */}
      <div>{props.children}</div>
    </Tooltip>
  )
}
